import { render, staticRenderFns } from "./middleTitle.vue?vue&type=template&id=30efaff4&scoped=true"
import script from "./middleTitle.vue?vue&type=script&lang=js"
export * from "./middleTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30efaff4",
  null
  
)

export default component.exports